"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        /**
         * Used for popped out windows to communicate to the real WindowManager and to act as a slimmed down WindowMananger for certain global events.
         * @internal
         */
        // tslint:disable-next-line:class-name
        var _WindowManagerPopout = /** @class */ (function () {
            function _WindowManagerPopout() {
                var _this = this;
                this.closeForms = true;
                this.windowCloseSuccess = true;
                /**
                 * Handler that listens for postMessage events and reacts accordingly if it is for the desired class.
                 * @remarks All PostMessage event handlers should ensure the following:
                 * 1. The `event.origin` is from the same location
                 * 2. The `event.data` is of the type we are expecting
                 * 3. The data contains some sort of unique identifier which our handler knows to look for and will not process if not found.
                 * @param event The message to handle
                 * @internal
                 */
                this.handleMessages = function (event) {
                    if (event.origin !== $dyn.util.getOrigin($dyn.util.location.location)) {
                        // Do not allow communication if it is cross origin.
                        return;
                    }
                    var options = event.data;
                    // Sanity check. Ensure these are coming for the WindowManager
                    if (typeof options === "object" && options.source === "WindowManagerPopout") {
                        _this.Commands[options.commandName].call(_this, options);
                    }
                };
                /**
                 * Sends a message to the parent window telling it that this window is closing.
                 * @internal
                 * @returns `true` if the message was successfully posted, otherwise, `false`.
                 */
                this.closeWindow = function () {
                    var data = {
                        closeForms: _this.closeForms,
                        commandName: $dyn.serverForm._WindowManagerFunction.closeWindow,
                        source: "WindowManager",
                        windowCloseSuccess: _this.windowCloseSuccess,
                        windowId: $dyn.serverForm._windowId,
                    };
                    return _this._postMessageToParentWindow(data);
                };
            }
            /**
             * Sends a mesage back to the parent window (to the WindowManager itself) that prePopout has been called.
             * @internal
             * @returns `true` if the message was successfully posted, otherwise, `false`.
             */
            _WindowManagerPopout.prototype.prePopout = function (options) {
                // Call PostMessage to the parent window.
                options.source = "WindowManager";
                options.commandName = $dyn.serverForm._WindowManagerFunction.prePopout;
                return this._postMessageToParentWindow(options);
            };
            /**
             * Sends a mesage back to the parent window (to the WindowManager itself) that windowLoadCallback has been called.
             * @internal
             * @returns `true` if the message was successfully posted, otherwise, `false`.
             */
            _WindowManagerPopout.prototype.windowLoadCallback = function (options) {
                this.focusWindow(); // This call is to place this popout in the focus state immediately when it loads.
                // Call PostMessage to the parent window.
                // Don't need to pass newWindow in the message, just have it here to match signatures.
                var data = {
                    commandName: $dyn.serverForm._WindowManagerFunction.windowLoadCallback,
                    rootId: options.rootId,
                    source: "WindowManager",
                    windowId: options.windowId,
                };
                return this._postMessageToParentWindow(data);
            };
            /**
             * Sends a mesage back to the parent window (to the WindowManager itself) that notifyFormReserialized has been called.
             * @internal
             * @returns `true` if the message was successfully posted, otherwise, `false`.
             */
            _WindowManagerPopout.prototype.notifyFormReserialized = function (rootId) {
                var data = {
                    commandName: $dyn.serverForm._WindowManagerFunction.notifyFormReserialized,
                    rootId: rootId,
                    source: "WindowManager",
                };
                return this._postMessageToParentWindow(data);
            };
            /**
             * Sends a mesage back to the parent window (to the WindowManager itself) that notifyFormDetached has been called.
             * @internal
             * @returns `true` if the message was successfully posted, otherwise, `false`.
             */
            _WindowManagerPopout.prototype.notifyFormDetached = function (rootId) {
                var data = {
                    commandName: $dyn.serverForm._WindowManagerFunction.notifyFormDetached,
                    rootId: rootId,
                    source: "WindowManager",
                };
                return this._postMessageToParentWindow(data);
            };
            /**
             * Sends a message back to the parent window (to the WindowManager itself) that closePopoutWindow has been called.
             * @internal
             * @param closeForms `true` to close the forms in the popout, otherwise, `false`.
             */
            _WindowManagerPopout.prototype.closePopoutWindow = function (closeForms) {
                // if we are popping out, we want to make sure the host window doesn't request close of any of the nested forms inside of us as those will be reserialized on the new popout.
                this.closeForms = closeForms;
                window.close();
            };
            /**
             * Callback method for when the host window is closed
             * @internal
             */
            _WindowManagerPopout.prototype.hostClosed = function () {
                // We are being notified that the host window has closed
                // Show a message to the user and clean up the popout (if needed) so we don't error out
                $dyn.showMessageBox({
                    callback: function () {
                        // Message box was dismissed, apply the disabled overlay so that the window becomes read only.
                        $("#DisconnectedDiv").show();
                        $dyn.warn({ Message: $dyn.label("WindowManager_HostClosed"), Label: "WindowManager_HostClosed" });
                    },
                    showOkButton: true,
                    Text: $dyn.label("WindowManager_HostClosed"),
                });
                // Create a stub parentWindow object so that further communications are handled.
                $dyn.parentWindow = {
                    postMessage: function () { },
                };
            };
            /**
             * Callback method for when a global unblock occurs.
             * @internal
             */
            _WindowManagerPopout.prototype.globalUnBlocked = function () {
                $dyn.log.navigation && $dyn.log.navigation("WindowManager: globalUnBlocked called");
                $dyn.shell.unBlockUserInteraction();
            };
            /**
             * Callback method for when a global block occurs.
             * @internal
             */
            _WindowManagerPopout.prototype.globalBlocked = function () {
                $dyn.log.navigation && $dyn.log.navigation("WindowManager: globalBlocked called");
                $dyn.shell.blockUserInteractionNoWait("WindowManager: globalBlocked");
            };
            /**
             * Callback method for when a call to request all popouts is made. This method has no effect on other windows, since popouts don't own any of the other child windows.
             * @internal
             * @param successCallback Callback for after all popouts are closed
             * @param errorCallback Unused.
             */
            _WindowManagerPopout.prototype.requestCloseAllPopouts = function (successCallback, errorCallback) {
                // nothing to do in popouts, we don't own any of the child windows
                if (typeof successCallback === "function") {
                    successCallback();
                }
                else {
                    $dyn.logWarning("WindowManagerPopout: closeAllPopouts should be called with a callback.");
                }
            };
            /**
             * Attempts to close the forms in the window, then close the window.
             * @internal
             */
            _WindowManagerPopout.prototype.requestClosePopout = function () {
                var _this = this;
                var successCallback = function () {
                    _this.windowCloseSuccess = true;
                    _this.closePopoutWindow(true);
                };
                var errorCallback = function () {
                    _this.windowCloseSuccess = false;
                    _this.closeForms = true;
                    $dyn.serverForm._windowManager.closeWindow();
                };
                $dyn.shell.closeWindowFormsBeforeNavigating(successCallback, errorCallback);
            };
            /**
             * Forces the current window closed.
             * @internal
             */
            _WindowManagerPopout.prototype.forceClosePopout = function () {
                this.closePopoutWindow(true);
            };
            /**
             * Determines if the current window is focused.
             * @internal
             */
            _WindowManagerPopout.prototype.isFocused = function () {
                return this._focusedWindowId === $dyn.serverForm._windowId;
            };
            /**
             * Called when this window gets focus
             * @remarks Called from window.focus event to notify this popout window manager that it has received focus.
             * This function also broadcasts that message to the parent window in order that all other windows can be notified.
             * @internal
             */
            _WindowManagerPopout.prototype.focusWindow = function () {
                this.notifyFocusWindow({ id: $dyn.serverForm._windowId });
                this._broadcastFocusWindow($dyn.serverForm._windowId);
            };
            /**
             * Callback method for when another window has received focus
             * @internal
             */
            _WindowManagerPopout.prototype.notifyFocusWindow = function (options) {
                this._focusedWindowId = options.id;
            };
            /**
             * Applies the user settings from the parent to the current window.
             * @internal
             */
            _WindowManagerPopout.prototype.transferUserSettings = function (options) {
                if (options) {
                    $dyn.user().unpack(options.packedUserSettings);
                }
            };
            /**
             * Applies the Shell settings from the parent to the current window.
             * @internal
             */
            _WindowManagerPopout.prototype.transferShellSettings = function (options) {
                if (options) {
                    $dyn.shell.unpack(options.packedShellSettings);
                }
            };
            /**
             * Sends a mesage back to the parent window (to the WindowManager itself)
             * @internal
             * @param data The data to post to the parent window
             * @returns `true` if the message was successfully posted, otherwise, `false`.
             */
            _WindowManagerPopout.prototype._postMessageToParentWindow = function (data) {
                if (!$dyn.parentWindow) {
                    $dyn.logError("Trying to post message to parentWindow which does not exist.");
                    return;
                }
                return $dyn.postMessage($dyn.parentWindow, { data: data });
            };
            /**
             * Notifies the parent window that the window with the given ID has been focused.
             * @param id The ID of the focused window
             */
            _WindowManagerPopout.prototype._broadcastFocusWindow = function (id) {
                var data = {
                    commandName: $dyn.serverForm._WindowManagerFunction.notifyFocusWindow,
                    id: id,
                    source: "WindowManager",
                };
                this._postMessageToParentWindow(data);
            };
            return _WindowManagerPopout;
        }());
        serverForm._WindowManagerPopout = _WindowManagerPopout;
        _WindowManagerPopout.prototype.Commands = {
            forceClosePopout: $dyn.serverForm._WindowManagerPopout.prototype.forceClosePopout,
            globalBlocked: $dyn.serverForm._WindowManagerPopout.prototype.globalBlocked,
            globalUnBlocked: $dyn.serverForm._WindowManagerPopout.prototype.globalUnBlocked,
            hostClosed: $dyn.serverForm._WindowManagerPopout.prototype.hostClosed,
            notifyFocusWindow: $dyn.serverForm._WindowManagerPopout.prototype.notifyFocusWindow,
            requestClosePopout: $dyn.serverForm._WindowManagerPopout.prototype.requestClosePopout,
            transferShellSettings: $dyn.serverForm._WindowManagerPopout.prototype.transferShellSettings,
            transferUserSettings: $dyn.serverForm._WindowManagerPopout.prototype.transferUserSettings,
        };
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=WindowManagerPopout.js.map
